import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../consts/routes';
import { useEffect } from 'react';

export function RequireAuthenticated({ children }: { children: JSX.Element }) {
  const { isAuthenticated, checkAuth } = useAuth();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     // navigate(-1);
  //     // navigate(ROUTES.signIn);
  //   }
  // }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    checkAuth();
    return null;
  }

  return children;
}
